<template>
  <div class="page">
    <v-container fluid>
      <v-form ref="form">
        <v-row class="d-flex justify-center mt-3">
          <sigfoco-date-picker
            ref="dataInicioPicker"
            v-model="form.filters.dataInicio"
            label="Início do Período"
            :cols="2"
            removeIcon
            :dataEdicao="form.filters.dataInicio"
          ></sigfoco-date-picker>
          <v-text class="d-flex align-center justify-center" style="margin-top: -20px;">até</v-text>
          <sigfoco-date-picker
            ref="dataFimPicker"
            v-model="form.filters.dataFim"
            label="Fim do Período"
            :cols="2"
            removeIcon
            :dataEdicao="form.filters.dataFim"
          ></sigfoco-date-picker>
          <v-col cols="3">
            <v-autocomplete
              label="Perfil"
              :items="form.lists.listPerfis"
              item-text="nome"
              item-value="id"
              v-model="form.filters.perfis"
              outlined
              dense
            ></v-autocomplete>
          </v-col>
          <sigfoco-select-ativo
            :cols="3"
            v-model="form.filters.ativo"
            labelType="Situação"
          ></sigfoco-select-ativo>
        </v-row>
        <div class="text-center">
          <v-col cols="12">
            <sigfoco-tooltip
              :text="'Buscar'"
              :icon="'mdi-magnify'"
              @click="buscarPeriodos()"
            ></sigfoco-tooltip>
            <sigfoco-tooltip
              :text="'Limpar'"
              :icon="'mdi-eraser'"
              @click="resetForm()"
            ></sigfoco-tooltip>
            <sigfoco-tooltip
              :text="'Incluir'"
              :icon="'mdi-plus'"
              @click="openDialogManterPeriodoFormacao()"
            ></sigfoco-tooltip>
          </v-col>
        </div>
      </v-form>
      <v-data-table
        class="mt-5"
        :headers="headers"
        :items="form.lists.listPeriodoFormacao"
        :items-per-page="10"
        :footer-props="$footerProps"
        show-expand
        :expanded.sync="expanded"
      >
        <template v-slot:[`item.dataInicio`]="{ item }">
          {{ formatDate(item.dataInicio) }}
        </template>
        <template v-slot:[`item.dataFim`]="{ item }">
          {{ formatDate(item.dataFim) }}
        </template>
        <template v-slot:[`item.perfis`]="{ item }">
          {{ item.perfis }}
        </template>
        <template v-slot:[`item.ativo`]="{ item }">
          <sigfoco-label-ativo-inativo :ativo="item.ativo"></sigfoco-label-ativo-inativo>
        </template>
        <template v-slot:[`item.acoes`]="{ item }">
          <sigfoco-tooltip
            :text="'Visualizar'"
            :icon="'mdi-eye-outline'"
            :small="true"
            @click="openDialogVisualizarPeriodoFormacao(item)"
          ></sigfoco-tooltip>
          <sigfoco-tooltip
            :text="'Editar'"
            :icon="'mdi-pencil'"
            :small="true"
            @click="openDialogManterPeriodoFormacao(item)"
          ></sigfoco-tooltip>
          <sigfoco-tooltip
            :text="'Excluir'"
            :icon="'mdi-delete'"
            :small="true"
            @click="excluirPeriodoFormacao(item)"
          ></sigfoco-tooltip>
          <sigfoco-tooltip
            :text="`${item.ativo ? 'Inativar' : 'Ativar'}`"
            :icon="`${item.ativo ? 'mdi-toggle-switch' : 'mdi-toggle-switch-off'}`"
            :color="`${item.ativo ? 'var(--primary-button-color)' : 'silver'}`"
            :small="true"
            @click="inativarAtivarPeriodoFormacao(item)"
          ></sigfoco-tooltip>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td class="perfis" :colspan="headers.length">
            <v-chip-group active-class="primary--text" column>
              <v-chip
                class="chip-permissao"
                v-for="(perfil, i) in item.perfis"
                :key="i"
              >
                <v-icon class="perfil" small>mdi-account-multiple</v-icon>
                {{ perfil.nome }}
              </v-chip>
            </v-chip-group>
          </td>
        </template>
        <template v-slot:[`item.emUso`]="{ item }">
          <sigfoco-tooltip
            :text="'Detalhar Uso'"
            :icon="item.emUso ? 'mdi-check-circle-outline' : 'mdi-close-circle-outline'"
            :color="item.emUso ? 'green' : 'red'"
            :small="true"
            :disabled="!item.emUso"
            @click="openDialogDetalharUsoPeriodoFormacao(item)"
          ></sigfoco-tooltip>
        </template>
      </v-data-table>
    </v-container>
    <CadastrarEditarPeriodoFormacaoDialog
      :visible="dialogManterPeriodoFormacao.visible"
      :content="dialogManterPeriodoFormacao.content"
      :edit="dialogManterPeriodoFormacao.edit"
      @onClose="dialogManterPeriodoFormacao.close()"
      @onSave="buscarPeriodos()"
    ></CadastrarEditarPeriodoFormacaoDialog> 
    <VisualizarPeriodoFormacaoDialog
      :visible="dialogVisualizarPeriodoFormacao.visible"
      :content="dialogVisualizarPeriodoFormacao.content"
      @onClose="dialogVisualizarPeriodoFormacao.close()"
    ></VisualizarPeriodoFormacaoDialog>
    <DetalharUsoPeriodoFormacaoDialog
      :visible="dialogDetalharUsoPeriodoFormacao.visible"
      :content="dialogDetalharUsoPeriodoFormacao.content"
      @onClose="dialogDetalharUsoPeriodoFormacao.close()"
      ></DetalharUsoPeriodoFormacaoDialog>
  </div>
</template>

<script>
import { Dialog} from "~/commons/classes/dialog";
import { PeriodoFormacao } from "~/commons/classes/periodo-formacao";
import ManterPeriodoFormacaoService from '~/services/manter-periodo-formacao.service';
import AuthService from '~/services/auth.service';
import CadastrarEditarPeriodoFormacaoDialog from "./dialogs/CadastrarEditarPeriodoFormacaoDialog.vue";
import DetalharUsoPeriodoFormacaoDialog from "./dialogs/DetalharUsoPeriodoFormacaoDialog.vue";
import VisualizarPeriodoFormacaoDialog from "./dialogs/VisualizarPeriodoFormacaoDialog.vue";
import ManterPerfilService from '~/services/manter-perfil.service';
export default {
  name: "ManterPeriodoFormacaoView",
  mixins: [ManterPeriodoFormacaoService, AuthService, ManterPerfilService],
  components: {
    CadastrarEditarPeriodoFormacaoDialog,
    VisualizarPeriodoFormacaoDialog,
    DetalharUsoPeriodoFormacaoDialog
  },
  data: () => ({
    dialogManterPeriodoFormacao: Dialog.Build(),
    dialogVisualizarPeriodoFormacao: Dialog.Build(),
    dialogDetalharUsoPeriodoFormacao: Dialog.Build(),
    form: {
      filters: {
        perfis: null,
        dataInicio: null,
        dataFim: null,
        ativo: null,
      },
      lists: {
        listPeriodoFormacao: [],
        listPerfis: [],
      }
    },
    headers: [
      { text: "Início do Período", align: "center", value: "dataInicio" },
      { text: "Fim do Período", align: "center", value: "dataFim" },
      { text: "Perfil", align: "center", value: "data-table-expand" },
      { text: "Situação", align: "center", value: "ativo" },
      { text: "Ações", align: "center", value: "acoes", sortable: false },
      { text: "Em uso", align: "center", value: "emUso", sortable: false },
    ]
  }),
  methods: {
    openDialogManterPeriodoFormacao(periodoFormacao) {
      if (periodoFormacao) {
        this.$visualizarPeriodoFormacao(periodoFormacao).then(({ data }) => {
          const periodo = data.resposta;
          periodo.dataInicio = periodo.dataInicio ? new Date(periodo.dataInicio).toISOString().substr(0, 10) : null;
          periodo.dataFim = periodo.dataFim ? new Date(periodo.dataFim).toISOString().substr(0, 10) : null;
          this.dialogManterPeriodoFormacao.open(periodo, true);
        });
      } else {
        this.dialogManterPeriodoFormacao.open(PeriodoFormacao.Build());
      }
    },
    openDialogVisualizarPeriodoFormacao(periodoFormacao) {
      this.$visualizarPeriodoFormacao(periodoFormacao).then(
        ({ data }) => (this.dialogVisualizarPeriodoFormacao.open(data.resposta))
      );
    },
    buscarPeriodos() {
      this.$buscarPeriodos({ params: this.form.filters }).then(({ data }) => {
        this.form.lists.listPeriodoFormacao = data.itens;
      }).catch((error) => {
        console.error("Erro ao buscar períodos:", error);
      });
    },
    inativarAtivarPeriodoFormacao(periodoFormacao) {
      this.$swal({
        text: `Deseja confirmar a ${periodoFormacao.ativo ? "inativação" : "ativação"} do Período?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonText: `Confirmar`,
        cancelButtonText: `Cancelar`,
      }).then(() => {
        if(periodoFormacao.emUso) {
            this.mostrarModalEmUso(periodoFormacao);
          } else {
            this.$inativarAtivarPeriodoFormacao(
            { id: periodoFormacao.id },
            periodoFormacao.id
          ).then(({ data }) => {
            this.$notifySuccess(`${data.mensagem}`);
            this.buscarPeriodos();
          });
          }
        }
      );
    },
    excluirPeriodoFormacao(periodoFormacao) {
      this.$swal({
        text: `Deseja confirmar a exclusão do Período?`,
        type: "error",
        showCancelButton: true,
        confirmButtonText: `Confirmar`,
        cancelButtonText: `Cancelar`,
      }).then(() => {
        if(periodoFormacao.emUso){
            this.mostrarModalEmUso(periodoFormacao);
          } else {
              this.$excluirPeriodoFormacao(
              { id: periodoFormacao.id },
              periodoFormacao.id
            ).then(({ data }) => {
              this.$notifySuccess(`${data.mensagem}`);
              this.buscarPeriodos();
            });
          }
        }
      );
    },  
    resetForm() {
      this.$resetForm();
      this.form.lists.listPeriodoFormacao = [];
      this.form.filters.dataInicio = null;
      this.form.filters.dataFim = null;
      this.form.filters.perfis = null;
      this.form.filters.ativo = null;
      this.expanded = [];
      if (this.$refs.dataInicioPicker) {
        this.$refs.dataInicioPicker.reset();
      }
      if (this.$refs.dataFimPicker) {
        this.$refs.dataFimPicker.reset();
      }

    },
    mostrarModalEmUso(item) {
      const qtd = item.quantidadeEmUso;
      this.$swal({
        text: `O registro não pode ser inativado ou excluído, pois está em uso em ${qtd} funcionalidade(s).`,
        type: "warning",
        confirmButtonText: "OK",
      });
    },

    openDialogDetalharUsoPeriodoFormacao(periodoFormacao) {
      this.$detalharUsoPeriodoFormacao(periodoFormacao).then(
        ({ data }) => (this.dialogDetalharUsoPeriodoFormacao.open(data.resposta))
      );
    },
    formatDate(date) {
      if (!date) return '';
      const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
      return new Date(date).toLocaleDateString('pt-BR', options);
    }
  },
  mounted() {
    this.$buscarPerfis({ params: { situacao: true } }).then(({ data }) => {
      this.form.lists.listPerfis = data.lista;
    });
  }
};
</script>
